import React from "react";

const values = [
  {
    title: "Simplicity",
    description: "Travel selling shouldn’t be complicated",
    image: "/valueSimple.png",
  },
  {
    title: "Accessibility",
    description: "Anyone can become a travelpreneur",
    image: "/valueAccessibility.png",
  },
  {
    title: "Profitability",
    description: "Every booking should grow your business",
    image: "/valueProfitability.png",
  },
  {
    title: "Support",
    description: "24/7 availability to back your growth",
    image: "/valueSupport.png",
  },
];

function ValueCard({ title, description, image }) {
  return (
    <div
      className="
        shrink-0 scroll-ml-4 snap-start
        w-[90%]
        rounded-xl bg-gray-100
        p-5 mr-4
      "
    >
      <img src={image} alt="" className="w-24 h-24 object-cover mb-2" />

      <h3 className="text-lg font-semibold text-black mb-2">{title}</h3>
      <p className="mt-2 text-gray-500 text-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
}

export default function HomeValuesSection() {
  return (
    <section className="w-full px-6 py-10 bg-white">
      <h2 className="text-2xl font-bold text-center mb-6">Our Values</h2>

      {/* Horizontal scroller */}
      <div
        className="
          -mx-2 px-2
          flex overflow-x-auto
          snap-x snap-mandatory
          no-scrollbar
          pb-2
        "
      >
        {values.map((v, i) => (
          <ValueCard key={i} {...v} />
        ))}
      </div>

      {/* Hide scrollbar */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}
